<template>
  <v-data-table
      v-model="selectedRows"
      :headers="headers"
      :items="rows"
      :hide-default-footer="true"
      disable-pagination
      :loading="loading"
      mobile-breakpoint="0"
      class="elevation-1"
      show-expand
      item-key="CustomId"
      single-expand
      disabe-sort
      show-select
  >
    <template v-slot:expanded-item="{ item, headers }">
      <td :colspan="headers.length" style="padding: 0">
        <v-card flat>
          <SubjectReportListByStudentAndAchievement
              :ExamIds="exams.map((exam) => exam.Id)"
              :GroupingPropertyIds="[item.ParentSubjectId]"
              :GroupingPropertyName="'ParentSubject'"
              :assessment-point-calculation-type-id="item.AssessmentPointCalculationTypeId"
          />
        </v-card>
      </td>
    </template>
    <template v-slot:top>
      <v-toolbar flat>
        <v-col>
          <c-lesson-branch v-model="lessonBranchIds" multiple="" :exam-ids="exams.map((exam) => exam.Id)"
                           @change="getDataFromApi"></c-lesson-branch>
        </v-col>
        <v-col v-if="!$vuetify.breakpoint.mobile" class="d-flex justify-content-end">
          <v-btn
              color="primary"
              :disabled="selectedRows.length === 0"
              :loading="exportingPdf"
              @click="exportToPdf"
          >
            <v-icon left small>mdi-file-pdf-box</v-icon>
            Seçilen Yanlış ve Boş Soruları PDF'e Aktar
          </v-btn>
        </v-col>
      </v-toolbar>
      <v-toolbar flat>
        <v-col>
          <v-range-slider
              label="Başarı Yüzdesi"
              v-model="scyRange"
              max="100"
              min="0"
              :thumb-size="20"
              thumb-label="always"
              step="1"
              class="mt-6"
              @change="getDataFromApi"
          ></v-range-slider>
        </v-col>
      </v-toolbar>
      <v-toolbar v-if="$vuetify.breakpoint.mobile" flat>
        <v-col class="d-flex justify-content-center">
          <v-btn
              color="primary"
              :disabled="selectedRows.length == 0"
              :loading="exportingPdf"
              @click="exportToPdf"
          >
            <v-icon left small>mdi-file-pdf-box</v-icon>
            Seçilen Yanlış ve Boş Soruları PDF'e Aktar
          </v-btn>
        </v-col>
      </v-toolbar>
    </template>
    <template v-slot:[`item.SuccessRate`]="{ item }">
      <v-progress-linear
          :color="getColor(item.SuccessRate)"
          :value="item.SuccessRate > 0 ? item.SuccessRate : 0"
          height="25"
          readonly
          rounded
      >
        <strong>{{ Math.ceil(item.SuccessRate > 0 ? item.SuccessRate : 0) }}%</strong>
      </v-progress-linear>
    </template>
    <template v-slot:[`item.QuestionCount`]="{ item }">
      {{ item.CorrectAnswerCount + item.WrongAnswerCount + item.EmptyAnswerCount }}
    </template>
    <template v-slot:[`item.HomeworkQuestionCount`]="{ item }">
      <div class="text-center">
        <v-progress-circular
            v-if="loadingHomework"
            indeterminate
            color="primary"
        ></v-progress-circular>
        <span v-if="item.TestCount > 0">
          <v-tooltip bottom :color="getColor((item.CompletedTestCount / item.TestCount) * 100)">
                <template v-slot:activator="{ on, attrs }">
                  <v-progress-linear
                      :color="getColor((item.CompletedTestCount / item.TestCount) * 100)"
                      :value="(item.CompletedTestCount / item.TestCount) * 100"
                      height="25"
                      readonly
                      style="min-width: 50px"
                      v-bind="attrs"
                      v-on="on"
                      rounded
                  >
                    <strong>{{ Math.ceil((item.CompletedTestCount / item.TestCount) * 100) }}%
                      <a
                          target="_blank"
                          :href="
                          '/odev-karnesi/' +
                          '?LessonId=' +
                          item.LessonId +
                          '&SubjectId=' +
                          item.SubjectId +
                          '&ParentSubjectId=' +
                          item.ParentSubjectId
                        "
                      >
                        <v-icon small v-b-tooltip.hover.right="'Ödev Karnesine Git'">
                          mdi-arrow-right-bold
                        </v-icon>
                      </a>
                    </strong>
                  </v-progress-linear>
                </template>
                <span style="color: black"
                >İşaretlenen soru sayısı: {{ item.CompletedQuestionCount }} <br/>
                  İşaretlenmeyen soru sayısı:
                  {{ item.NotCompletedQuestionCount }}
                </span>
              </v-tooltip>
        </span>
      </div>
    </template>
    <template v-slot:[`item.HomeworkSCY`]="{ item }">
      <div class="text-center">
        <v-progress-circular
            v-if="loadingHomework"
            indeterminate
            color="primary"
        ></v-progress-circular>
        <span v-if="item.SCY">
          <v-progress-linear
              :color="getColor(item.SCY)"
              :value="item.SCY"
              height="25"
              readonly
              rounded
          >
            <strong>{{ Math.ceil(item.SCY) }}%</strong>
          </v-progress-linear>
        </span>
      </div>
    </template>
    <template v-slot:no-data>
      <span>VERİ BULUNAMADI</span>
    </template>
  </v-data-table>
</template>

<script>
import ApiService from '@/core/services/api.service.js'
import SubjectReportListByStudentAndAchievement
  from '@/view/components/ExamReport/SubjectReportListByStudentAndAchievement.vue'
import {Capacitor} from '@capacitor/core'
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

export default {
  components: {SubjectReportListByStudentAndAchievement},
  props: ['exams', 'assessmentPointCalculationTypeId'],
  data() {
    return {
      scyRange: [0, 100],
      search: '',
      rows: [],
      loading: true,
      options: {sortBy: ['LessonBranchName']},
      headers: [
        {text: 'Ders Branşı', value: 'LessonBranchName', sortable: false},
        {text: 'Puan Tipi', value: 'AssessmentPointCalculationTypeName', sortable: false},
        {text: 'Konu', value: 'SubjectName', sortable: false},
        {text: 'Soru Sayısı', value: 'QuestionCount', sortable: false},
        {text: 'Doğru', value: 'CorrectAnswerCount', sortable: false},
        {text: 'Yanlış', value: 'WrongAnswerCount', sortable: false},
        {text: 'Boş', value: 'EmptyAnswerCount', sortable: false},
        {text: 'Net', value: 'TotalNet', sortable: false},
        {text: 'Konu Başarı Yüzdesi', value: 'SuccessRate', sortable: false},
        {text: 'Soru İşaretleme Oranı', value: 'HomeworkQuestionCount', sortable: false},
        {text: 'Doğru Cevaplama Oranı', value: 'HomeworkSCY', sortable: false}
      ],
      loadingHomework: true,
      lessonBranchIds: [],
      selectedRows: [],
      exportingPdf: false
    }
  },
  watch: {
    exams() {
      this.getDataFromApi()
    },
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true
    },
    assessmentPointCalculationTypeId() {
      this.getDataFromApi()
    }
  },
  mounted() {
    this.getDataFromApi()
  },
  methods: {
    getColor(successRate) {
      if (successRate > 75) return 'green'
      else if (successRate > 40) return 'yellow'
      else return 'red'
    },

    getDataFromApi() {
      if (this.exams && this.exams.length > 0) {
        this.loading = true
        this.rows = []
        ApiService.setHeader()
        ApiService.post('api/CombinedExamResultReport/SubjectAnalysis/SubjectReport', {
          ExamIds: this.exams.map((s) => s.Id),
          MinSuccessRate: this.scyRange[0],
          MaxSuccessRate: this.scyRange[1],
          StudentId: 0,
          AssessmentPointCalculationTypeId: this.assessmentPointCalculationTypeId,
          LessonBranchIds: this.lessonBranchIds,
          UseParentSubject: true
        }).then((data) => {
          this.rows = data.data
          this.selectedRows = []
          this.loading = false
          this.getHomeworkDataFromApi()
        }).catch(({response}) => {
          ApiService.showError(response)
          this.loading = false
        })
      }
    },
    getHomeworkDataFromApi() {
      this.loadingHomework = true
      ApiService.setHeader()
      ApiService.post('api/Homework/reports/StudentSubjectReport', {
        SubjectIds: this.rows.map((s) => s.SubjectId),
        UseParentSubject: true
      }).then((data) => {
        if (data.data.length === 0) {
          this.loadingHomework = false
          return
        }

        for (let index = 0; index < data.data.length; index++) {
          const element = data.data[index]
          const elements = this.rows.filter((r) => r.SubjectId === element.SubjectId)

          if (elements.length === 0) continue
          elements.forEach((f) => {
            f.CompletedTestCount = element.CompletedTestCount
            f.NotCompletedTestCount = element.NotCompletedTestCount
            f.TestCount = element.TestCount
            f.CompletedQuestionCount = element.CompletedQuestionCount
            f.NotCompletedQuestionCount = element.NotCompletedQuestionCount
            f.SCY = Math.round(element.SCY)
          })
        }
        this.loadingHomework = false
      }).catch(({response}) => {
        ApiService.showError(response)
        this.loadingHomework = false
      })
    },

    exportToPdf() {
      this.exportingPdf = true
      ApiService.setHeader()
      ApiService.post('api/ExamReport/student-wrong-questions-report', {
        StudentId: 0,
        SubjectIds: this.selectedRows.map((s) => s.SubjectId),
        ExamIds: this.exams.map((s) => s.Id),
        UseParentSubject: true
      }).then((data) => {
        if (data.data.length > 0) {
          this.downloadPdf(data.data)
        } else {
          ApiService.showError({message: 'Seçili konular için yanlış veya boş soru bulunmamaktadır.'})
          this.exportingPdf = false
        }
      }).catch(({response}) => {
        ApiService.showError(response)
        this.exportingPdf = false
      })
    },

    async downloadPdf(questions) {
      if (questions.length === 0) {
        ApiService.showAlert('Lütfen en az bir soru seçiniz.')
        this.exportingPdf = false
        return
      }

      if (questions.length > 300) {
        ApiService.showAlert('PDF\'e aktarılabilecek maksimum soru sayısı 300\'dür. Lütfen daha az soru seçiniz.')
        this.exportingPdf = false
        return
      }

      this.exportingPdf = true

      try {
        ApiService.setHeader()
        const response = await ApiService.postwithconfig('api/ExamReport/export-wrong-questions-pdf', {
          StudentId: 0,
          Questions: questions
        }, {responseType: 'blob'})

        const fileName = `soru-analizi-${new Date().getTime()}.pdf`
        const blob = new Blob([response.data], { type: 'application/pdf' })

        // Mobil cihaz kontrolü
        if (Capacitor.isNativePlatform()) {
          // Blob'u base64'e çevir
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = async () => {
            const base64data = reader.result.split(',')[1];
            
            try {
              // Dosyayı cache dizinine kaydet
              const savedFile = await Filesystem.writeFile({
                path: fileName,
                data: base64data,
                directory: Directory.Documents
              });

              // Share API ile dosyayı aç/paylaş
              await Share.share({
                title: 'Soru Analizi PDF',
                text: 'Yanlış ve boş sorular analizi',
                url: savedFile.uri,
                dialogTitle: 'PDF\'i görüntüle veya paylaş'
              });
              
              ApiService.showAlert('PDF hazır.', 'success')
            } catch (shareError) {
              ApiService.showAlert('PDF açılırken bir hata oluştu.  \n  ' + shareError , 'error');
            }
          };
        } else {
          // Web için klasik indirme yöntemi
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          ApiService.showAlert('PDF başarıyla indirildi.', 'success')
        }
      } catch (error) {
        ApiService.showError(error)
      } finally {
        this.exportingPdf = false
      }
    }
  }
}
</script>
